var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrap" },
    [
      _c("span", {
        staticClass: "el-icon-arrow-left scroll-left",
        on: { click: _vm.toHead }
      }),
      _c(
        "el-scrollbar",
        {
          ref: "scrollContainer",
          staticClass: "scroll-container",
          attrs: { vertical: false },
          nativeOn: {
            wheel: function($event) {
              $event.preventDefault()
              return _vm.handleScroll($event)
            }
          }
        },
        [_vm._t("default")],
        2
      ),
      _c("span", {
        staticClass: "el-icon-arrow-right scroll-right",
        on: { click: _vm.toEnd }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }